import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = [
    'filterWrapper',
    'filterValues',
    'filterValue',
    'saveButton',
    'openIcons',
    'closeIcons',
  ];

  connect() {
    this.closeAllFilters();
    useClickOutside(this, { element: this.filterWrapperTarget });

    this.saveButtonTargets.forEach((button) => {
      button.addEventListener('click', this.applyFilters, true);
    });

    this.filterValueTargets.forEach((checkbox) => {
      checkbox.addEventListener('change', this.updateButtonBorder);
    });

    const uniqueListboxes = new Set();
    this.filterValueTargets.forEach((checkbox) => {
      const listbox = checkbox.closest('[role="listbox"]');
      uniqueListboxes.add(listbox);
    });

    uniqueListboxes.forEach((listbox) => {
      if (listbox) {
        this.updateButtonBorder({ currentTarget: listbox });
      }
    });
  }

  clickOutside = (event) => {
    if (this.filterValuesTarget.contains(event.target)) return;
    this.closeAllFilters();
  };

  applyFilters = (event) => {
    const url = new URL(window.location.href);

    const attributes = new Set();
    this.filterValueTargets.forEach((checkbox) => {
      const attr = checkbox.getAttribute('data-filter-attribute');
      attributes.add(attr);
    });

    attributes.forEach((attr) => {
      let paramName = `q[${attr}]`;
      if (attr.endsWith('_in')) {
        paramName += '[]';
      }
      url.searchParams.delete(paramName);
    });

    this.filterValueTargets.forEach((checkbox) => {
      const filterAttribute = checkbox.getAttribute('data-filter-attribute');
      let paramName = `q[${filterAttribute}]`;
      if (filterAttribute.endsWith('_in')) {
        paramName += '[]';
      }
      if (checkbox.checked) {
        url.searchParams.append(paramName, checkbox.id);
      }
    });

    event.target.setAttribute('href', url.toString());
    window.history.pushState({}, '', url.toString());
    this.visitUrl(url);

    this.closeAllFilters();

    const { filterAttribute } = event.target.closest('[role="listbox"]').dataset;
    document.querySelector(`[data-filter-attribute="${filterAttribute}"]`).focus();
  };

  toggleFilterValues = (event) => {
    const open = JSON.parse(event.currentTarget.nextElementSibling.dataset.visible);
    const filterValuesList = event.currentTarget.nextElementSibling;
    const openIcon = event.currentTarget.querySelector('svg[data-icon="openIcon"]');
    this.closeAllFilters();

    if (open) {
      openIcon.classList.remove('rotate-180');
    } else {
      openIcon.classList.add('rotate-180');
    }

    filterValuesList.dataset.visible = !open;
    event.currentTarget.setAttribute('aria-expanded', !open);
  };

  closeAllFilters = () => {
    this.filterValuesTargets.forEach((filterValues) => {
      const button = document.querySelector(`[aria-controls="${filterValues.id}"]`);
      if (filterValues.dataset.visible === 'true') {
        button?.querySelector('svg[data-icon="openIcon"]').classList.remove('rotate-180');
      }
      filterValues.dataset.visible = false;
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  };

  visitUrl = (url) => {
    get(url, { responseKind: 'turbo-stream' });
  };

  clearFilters(event) {
    const listbox = event.currentTarget.closest('[role="listbox"]');
    if (listbox) {
      listbox.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });
      this.updateButtonBorder({ currentTarget: listbox });
    }
  }

  updateButtonBorder = (event) => {
    const listbox = event.currentTarget.closest('[role="listbox"]');
    if (!listbox) return;

    const { filterAttribute } = listbox.dataset;
    const button = document.querySelector(`#filter-button-${filterAttribute}`);
    if (!button) return;

    const anyChecked = listbox.querySelectorAll('input[type="checkbox"]:checked').length > 0;

    if (anyChecked) {
      button.setAttribute('data-active', 'true');
    } else {
      button.removeAttribute('data-active');
    }
  };
}
